import React, { useState } from 'react'

import { ReactComponent as CashIcon } from 'assets/icons/dollar.svg'

import Search from 'util/modules/Pagination/components/Search'
import { useHistory } from 'react-router-dom'

const ManagementClient: React.FC = () => {
  const location = useHistory()

  const [filter, setFilter] = useState({
    name: '',
    email: '',
    username: ''
  })

  return (
    <div className="row panel managementclients">
      <h2 className="row justify-start margin-bottom-16">
        <CashIcon height="30" width="35" /> Gestão de Clientes
      </h2>

      <div className="row align-end justify-start">
        <div className="form-control col-4" style={{ marginTop: -8 }}>
          <label>Nome</label>
          <Search
            url="/user"
            label='name'
            filter='p.name'
            filterType="filter_like"
            fields='id,p.name'
            match={['start']}
            selected={String(filter.name)}
            defaultValue={filter.name}
            options={{ returnKey: 'id', renderValue: 'name' }}
            onSelect={(id, list): void => {
              const find = list?.find(item => item.key === id)
              if (find) {
                setFilter({ ...filter, name: find?.value || '' })
                location.push(`/panel/balance/${id}`)
              }
            }}
          />
        </div>
        <div className="form-control col-4" style={{ marginTop: -8 }}>
          <label>E-mail</label>
          <Search
            url="/user"
            label='email'
            filter='p.email'
            filterType="filter_like"
            fields='id,p.email'
            match={['start']}
            selected={String(filter.email)}
            defaultValue={filter.email}
            options={{ returnKey: 'id', renderValue: 'email' }}
            onSelect={(id, list): void => {
              const find = list?.find(item => item.key === id)
              if (find) {
                setFilter({ ...filter, email: find?.value || '' })
                location.push(`/panel/balance/${id}`)
              }
            }}
          />
        </div>
        <div className="form-control col-4" style={{ marginTop: -8 }}>
          <label>Usuário</label>
          <Search
            url="/user"
            label='username'
            filter='username'
            filterType="filter_like"
            fields='id,username'
            match={['start']}
            selected={String(filter.username)}
            defaultValue={filter.username}
            options={{ returnKey: 'id', renderValue: 'username' }}
            onSelect={(id, list): void => {
              const find = list?.find(item => item.key === id)
              if (find) {
                setFilter({ ...filter, username: find?.value || '' })
                location.push(`/panel/balance/${id}`)
              }
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default ManagementClient
